"use client";

import { useEffect } from "react";
import { useStore } from "@/hooks/use-store";
import AuthModal from "@/components/Modal/Auth/AuthModal";
import DepositModal from "@/components/Modal/Deposit/DepositModal";
import { useQueryParam } from "@/hooks/use-query-param";
import { useHydratedStore } from "@/hooks/use-hydrated-store";

export default function Init() {
  const hydrated = useHydratedStore(); // ← ждём persist
  const { user, modal } = useStore();
  const { getParam, deleteParam } = useQueryParam();

  useEffect(() => {
    if (!hydrated) return;

    const modalType = getParam("modal");
    if (!modalType) return;

    if (user.isAuth) {
      if (modalType === "deposit") {
        setTimeout(() => {
          modal.showModal(<DepositModal />);
          deleteParam("modal");
          deleteParam("auto-active-promo");
        }, 500);
      }
    } else {
      modal.showModal(<AuthModal activeTab="registration" />);
    }
  }, [hydrated, user.isAuth]);

  return null;
}
